import type { Chapter } from "@repo/app-types/entities/course";
import type { FC } from "react";

interface ChapterItemTitleProps {
  index: number;
  chapter: Chapter;
}

/** Displays the chapter title or fallback to chapter number */
export const ChapterItemTitle: FC<ChapterItemTitleProps> = ({
  index,
  chapter,
}) => {
  const number = index + 1;
  const title = chapter.topic ?? `Chapter ${number}`;

  return (
    <div className="flex-1 overflow-hidden">
      <div
        className="truncate leading-6 font-semibold text-foreground"
        title={title}
      >
        {chapter.topic ? (
          <span>{chapter.topic}</span>
        ) : (
          <span className="text-muted-foreground">Chapter {number}</span>
        )}
      </div>
    </div>
  );
};
